var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('ald-text',{attrs:{"font-size":32}},[_vm._v(_vm._s(_vm.$t('message.generic.webConstruction')))]),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('img',{staticClass:"wrapper-image",attrs:{"src":_vm.underConstruction,"alt":"Under construction"}})]),_vm._v(" "),_c('Links')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }